import React from 'react';
import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';

const SEOHead = ({ 
  title, 
  description, 
  keywords, 
  image, 
  url,
  type = 'website',
  robots
}) => {
  const { i18n } = useTranslation();
  
  const defaultTitle = 'Javiland - Conectando Comunidades con Amor';
  const defaultDescription = 'Tienda especializada en productos de bienestar y artesanales. Productos únicos para tu bienestar.';
  const defaultImage = '/images/brand/logo-largo.png';
  const siteUrl = process.env.REACT_APP_SITE_URL || 'https://javiland.com';
  
  const seoTitle = title ? `${title} | ${defaultTitle}` : defaultTitle;
  const seoDescription = description || defaultDescription;
  const seoImage = image || `${siteUrl}${defaultImage}`;
  const seoUrl = url || siteUrl;
  
  return (
    <Helmet>
      {/* Primary Meta Tags */}
      <title>{seoTitle}</title>
      <meta name="title" content={seoTitle} />
      <meta name="description" content={seoDescription} />
      <meta name="keywords" content={keywords || 'javiland, bienestar, productos artesanales, tienda online, colombia'} />
      <meta name="language" content={i18n.language} />
      <meta name="author" content="Javiland" />
      
      {/* Open Graph / Facebook */}
      <meta property="og:type" content={type} />
      <meta property="og:url" content={seoUrl} />
      <meta property="og:title" content={seoTitle} />
      <meta property="og:description" content={seoDescription} />
      <meta property="og:image" content={seoImage} />
      <meta property="og:locale" content={i18n.language === 'es' ? 'es_CO' : i18n.language === 'en' ? 'en_US' : 'pt_BR'} />
      
      {/* Twitter */}
      <meta property="twitter:card" content="summary_large_image" />
      <meta property="twitter:url" content={seoUrl} />
      <meta property="twitter:title" content={seoTitle} />
      <meta property="twitter:description" content={seoDescription} />
      <meta property="twitter:image" content={seoImage} />
      
      {/* Additional */}
      <meta name="robots" content={robots || 'index, follow'} />
      <meta name="viewport" content="width=device-width, initial-scale=1.0" />
      <link rel="canonical" href={seoUrl} />
    </Helmet>
  );
};

export default SEOHead;

